'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';

// This component is only used in layout mode, we may be able to deprecate this soon
import { jsx as _jsx } from "react/jsx-runtime";
export default class ClickCatcher extends Component {
  constructor(...args) {
    super(...args);
    this.onClick = () => {
      this.props.onClickCallback();
    };
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      onClick: this.onClick,
      className: "hs-ipe-solid-overlay hs-ipe-overlay"
    });
  }
}
ClickCatcher.propTypes = {
  onClickCallback: PropTypes.func.isRequired
};